module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"google_map":"Google Map","open_str":"Open Street Map"},"es":{"google_map":"Mapa de Google","open_str":"Abrir mapa de calles"},"fr":{"google_map":"Google Map","open_str":"Ouvrir la carte des rues"},"sw":{"google_map":"Ramani ya Google","open_str":"Fungua Ramani ya Mtaa"}}')
  delete Component.options._Ctor
}
